import { memo } from 'react'
import cn from 'classnames'

import { Card } from '~/shared/ui/Card'
import { HStack } from '~/shared/ui/HStack'
import { VStack } from '~/shared/ui/VStack'
import { Text } from '~/shared/ui/Text'

import { ERROR_STATE_AVATAR_SIZE, ERROR_STATE_MASCOT_SIZE, ERROR_STATE_MASCOT_SRC } from './config'
import type { ErrorStateProps } from './types'

import styles from './ErrorState.module.scss'

/**
 * Ошибка/офлайн голосом Луни (спека 01, компонент 09). Красного здесь нет — красный
 * появляется только в маячке, деструктивных действиях и валидациях форм (правило 10).
 *
 * Раскладка по правке основателя: Луня над карточкой, карточка по центру области, текст и
 * кнопка внутри — тоже по центру. Прижатая к левому краю плашка с текстом читалась как
 * системная ошибка, а не как реплика Луни.
 */
export const ErrorState = memo(function ErrorState(props: ErrorStateProps) {
  const { variant = 'DEFAULT', illustration, overline, title, description, action } = props

  return (
    <div className={styles.root}>
      <img
        className={styles.mascot}
        src={ERROR_STATE_MASCOT_SRC}
        width={ERROR_STATE_MASCOT_SIZE}
        height={ERROR_STATE_MASCOT_SIZE}
        alt=''
      />
      <div className={styles.card}>
        <Card padding='M'>
          <VStack gap='SMALL_L' align='CENTER'>
            {(illustration || overline) && (
              <HStack gap='SMALL_M' align='CENTER'>
                {illustration && (
                  <div
                    className={cn(styles.avatar, variant === 'OFFLINE' && styles.avatar_OFFLINE)}
                    style={{ width: ERROR_STATE_AVATAR_SIZE, height: ERROR_STATE_AVATAR_SIZE }}
                  >
                    {illustration}
                  </div>
                )}
                {overline && (
                  <Text variant='OVERLINE' color='ACCENT_SOFT'>
                    {overline}
                  </Text>
                )}
              </HStack>
            )}
            <Text variant='BODY' align='CENTER'>
              {title}
            </Text>
            {description && (
              <Text variant='BODY_S' color='SECONDARY' align='CENTER'>
                {description}
              </Text>
            )}
            {action}
          </VStack>
        </Card>
      </div>
    </div>
  )
})
